module.exports = __webpack_public_path__ + "static/img/zn_no.2.53458cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zn_no.2.jpg
// module id = G+9b
// module chunks = 17